import React from "react";
import { ReactSVG } from "react-svg";

import LogoIcon from "@assets/TopconLogo/Icon.svg";
import LogoName from "@assets/TopconLogo/Name.svg";

import LogoContainer from "./styles";

interface LogoProps {
  /**
   * Compact, horizontal layout for use in navbars / inline contexts.
   * Defaults to the original stacked variant used by the login screen.
   */
  horizontal?: boolean;
}

const Logo: React.FC<LogoProps> = ({ horizontal }) => (
  <LogoContainer className="container" $horizontal={horizontal}>
    <ReactSVG className="logoIconSVG" src={LogoIcon} />
    <ReactSVG className="logoNameSVG" src={LogoName} />
  </LogoContainer>
);

Logo.defaultProps = {
  horizontal: false
};

export default Logo;
